import {
  AppleProviderOptions,
  AppleProviderResponse,
  GoogleLoginOptions,
  GoogleLoginResponseOnline,
  SocialLogin,
} from '@capgo/capacitor-social-login';
import { Grid } from '@mui/material';

import { capacitorService } from '../../../../application/CapacitorService';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';
import { SocialLoginProviders } from '../../context/reducer';
import { SocialLoginButton } from './SocialLoginButton';

interface RegisterSocialLoginButtonsProps {
  nextStep: (generatedToken: string, provider: SocialLoginProviders, accessToken: string, userName?: string) => void;
}

export const SocialLoginButtons = ({ nextStep }: RegisterSocialLoginButtonsProps) => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  async function handleLogin(provider: SocialLoginProviders) {
    try {
      const response = await SocialLogin.login(
        provider === `google`
          ? { provider, options: {} as GoogleLoginOptions }
          : { provider, options: {} as AppleProviderOptions }
      );

      let responseParsed;
      let name: string | null = null;
      switch (provider) {
        case `google`:
          responseParsed = response.result as GoogleLoginResponseOnline;
          name = responseParsed?.profile?.name;
          break;
        case `apple`:
          responseParsed = response?.result as AppleProviderResponse;
          name = responseParsed?.profile?.givenName; // TODO There is givenName and user, i guess is this one. But test.
          break;

        default:
      }
      const idToken = responseParsed?.idToken;
      const accessToken = responseParsed?.accessToken?.token;

      if (idToken && response.provider && accessToken)
        nextStep && nextStep(idToken, response.provider, accessToken, name ?? undefined);
    } catch (error: any) {
      if (error?.message === `Popup closed`) return;

      console.error(`Error during social login:`, error);

      showSnackbarMessage({
        messageIntlId: `drivers.register.login.error`,
        type: `error`,
      });
    }
  }

  return (
    <Grid container flexDirection="column" gap="10px">
      <SocialLoginButton onClick={handleLogin} socialAccount="google" />
      {capacitorService.isIOS() ? <SocialLoginButton onClick={handleLogin} socialAccount="apple" /> : null}
    </Grid>
  );
};
